<template>
  <div
    class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
  >
    <span
      class="hidden sm:inline-block sm:align-middle sm:h-screen"
      aria-hidden="true"
      >&#8203;</span
    >
    <div
      class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full h-screen w-full p-3.5"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="flex justify-between pl-4 pt-4 pr-4">
        <h5 class="text-gray-900 font-medium text-sm ">
          Select slot
        </h5>
        <button @click="handleFooterPopper(false)"><X /></button>
      </div>

      <div
        v-if="type === 'sessionData'"
        class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4"
      >
        <SessionBatchesAvailable v-on:batch-id="handleJoinModal" :data="data" />
      </div>
      <div
        v-if="type === 'courseData'"
        class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4"
      >
        <CourseGroupAvailables
          v-on:sessions-group="handleJoinModal"
          :data="data"
          :course_groups="data.course_groups.available.data"
          :selectedCourseSlotId="courseSlotId"
          :handleSelectOpenOnPopper="handleSelectOpenOnPopper"
        />
      </div>
      <div v-if="nextPageUrl && !isSelectOpen && !courseSlotId" class="px-5">
        <button
          class="ring-gray-800 ring-1 rounded-lg py-2 w-full"
          @click="handleShowMoreAvail(nextPageUrl)"
        >
          Show more slots
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import SessionBatchesAvailable from "@/components/SessionBatchesAvailable";
import CourseGroupAvailables from "@/components/CourseGroupAvailables";
import { X } from "@/components/icons";

export default {
  created() {
    this.courseSlotId = this.selectedCourseSlotId;
  },
  data() {
    return {
      isSelectOpen: false,
      courseSlotId: null,
    };
  },
  props: [
    "data",
    "type",
    "nextPageUrl",
    "handleShowMoreAvail",
    "handleFooterPopper",
    "handleJoinModal",
    "selectedCourseSlotId",
  ],
  components: {
    SessionBatchesAvailable,
    CourseGroupAvailables,
    X,
  },
  methods: {
    // handlePoper(value) {
    //   this.$emit("handlePopper", value);
    // },
    // handleShowMore(value) {
    //   this.$emit("handleShowMore", value);
    // },
    handleSelectOpenOnPopper(value) {
      this.isSelectOpen = value;
      this.courseSlotId = null;
    },
  },
};
</script>
